
module.directive('plural', function() {

    return {
        restrict: 'A',
        scope: {count: '=plural', noun: '@'},
        link: function(scope, element, attrs) {

            function getText() {
                var noun = scope.noun, count = scope.count;
                if (count === 0) { return "No " + noun + "s"}
                if (count === 1) { return "One " + noun}
                return count + " " + noun + "s";
            }

            function setText() {
                element.text(getText());
            }

            scope.$watch('count', setText);
        },
    };
});
